meedy.controller('meedy.applicationController', ['$scope', '$rootScope', '$state', '$mdToast', '$timeout', '$document', '$translate', '$window', '$location', '$log', '$mdDialog',
	'meedy.userModel', 'userModel', 'meedy.objectHelper', 'meedy.authModel', 'meedyConfig', 'meedy.authInterceptor', 'applicationModel',
	'$mdComponentRegistry', 'meedy.messagesModel', 'meedy.wizardModel', 'meedy.heartbeatModel', 'meedy.blobUtils',
	'meedy.videoConsultationModel', 'meedy.storedDocumentModel', '$q', '$cookies',
	function ($scope, $rootScope, $state, $mdToast, $timeout, $document, $translate, $window, $location, $log, $mdDialog,
			  userModel, edmUserModel, objectHelper, authModel, config, authInterceptor, applicationModel,
			  $mdComponentRegistry, messagesModel, wizardModel, heartbeatModel, blobUtils,
			  videoConsultationModel, storedDocumentModel, $q, $cookies) {
		
		$scope.bindWatchers = {};
		
		$scope.bindData = function (expression, target, targetScope) {
			var unwatcher = $rootScope.$watch(expression, function (newValue, oldValue, scope) {
				targetScope[target] = newValue;
			}, true);
			
			if (!$scope.bindWatchers[targetScope.$id]) {
				$scope.bindWatchers[targetScope.$id] = [];
			}
			
			$scope.bindWatchers[targetScope.$id].push(unwatcher);
		};
		
		$scope.bindChange = function (expression, handler, targetScope) {
			var unwatcher = $rootScope.$watch(expression, function (newValue, oldValue, scope) {
				handler.call(undefined, newValue, oldValue, scope);
			}, true);
			
			if (!$scope.bindWatchers[targetScope.$id]) {
				$scope.bindWatchers[targetScope.$id] = [];
			}
			
			$scope.bindWatchers[targetScope.$id].push(unwatcher);
			
			return unwatcher;
		};
		
		$scope.unbind = function (targetScope) {
			var scopeWatchers = $scope.bindWatchers[targetScope.$id];
			
			if (scopeWatchers) {
				_.each(scopeWatchers, function (unwatcher) {
					unwatcher();
				});
			}
			
			scopeWatchers.splice(0, scopeWatchers.length);
			delete $scope.bindWatchers[targetScope.$id];
		};
		
		// shortened translations
		$scope.T = function (key) {
			return $translate.instant(key);
		};
		
		// shortened object creation
		$scope.O = function (targetClassString, obj) {
			return objectHelper.createObject(eval(targetClassString), obj);
		};
		
		// shortened state dynamic url
		$scope.U = function (stateString, stateParams) {
			var state = eval(stateString);
			var url = $state.href(stateString, stateParams);
			return url;
		};
		
		//alert template
		$scope.alert = function (title, text, confirmLabel) {
			var alert = $mdDialog.alert({
				clickOutsideToClose: true,
				title: $translate.instant(title),
				content: $translate.instant(text),
				ok: confirmLabel || $translate.instant('T.MEEDY.UI.APPLICATION.OK')
			});
			$mdDialog.show(alert);
		};
		
		// heartbeat
		
		$scope.startHeartbeat = function () {
			
			if ($scope.didAction > 0 && userModel.currentUser) {
				$scope.didAction = 0;
				heartbeatModel.heartbeat();
				heartbeatModel.heartbeatEDM(userModel.currentUser.inEdm);
			}
			
			if ($scope.heartbeat) {
				$timeout.cancel($scope.heartbeat);
			}
			$scope.heartbeat = $timeout($scope.startHeartbeat, 5 * 1000 * 60);
		};
		
		// apply enums
		
		$scope.Enum = Enum;
		$scope.Constant = Constant;
		
		// data
		
		var goingToPreviousState = false;
		var previousStateHistory = [];
		var stateBeforeLogin = null;
		var forceStateChange = false;
		
		var MAX_RECONNECT_TRIES = 5;
		
		$scope.applicationName = applicationModel.applicationName;
		$scope.applicationCustomer = applicationModel.applicationCustomer;
		$scope.applicationVersion = applicationModel.applicationVersion;
		
		$scope.devMode = applicationModel.devMode;
		$scope.logoutUrl = config.LOGOUT_URL;
		
		$scope.customConfig = $scope.bindData(function () {
			return applicationModel.customConfig
		}, 'customConfig', $scope);
		
		$scope.currentState = $scope.bindData(function () {
			return applicationModel.currentState
		}, 'currentState', $scope);
		$scope.currentUrl = $scope.bindData(function () {
			return applicationModel.currentUrl
		}, 'currentUrl', $scope);
		
		$scope.isLoggedIn = $scope.bindData(function () {
			return applicationModel.isLoggedIn
		}, 'isLoggedIn', $scope);
		$scope.isLoading = $scope.bindData(function () {
			return applicationModel.isLoading
		}, 'isLoading', $scope);
		
		$scope.viewDirty = $scope.bindData(function () {
			return applicationModel.viewDirty
		}, 'viewDirty', $scope);
		$scope.viewReady = $scope.bindData(function () {
			return applicationModel.viewReady
		}, 'viewReady', $scope);
		$scope.fillViewportMode = $scope.bindData(function () {
			return applicationModel.fillViewportMode
		}, 'fillViewportMode', $scope);
		
		$scope.actionInProgress = $scope.bindData(function () {
			return applicationModel.actionInProgress
		}, 'actionInProgress', $scope);
		
		//For socket reconnecting
		$scope.reconnectCount = 0;
		
		//For detecting afk users
		$scope.didAction = 0;
		
		//Errors to ignore (not show any error message)
		$rootScope.ignoreError = [];
		
		//For hiding firstConfigurationPopup
		$scope.checkedFirstConfiguration = false;
		
		$scope.bindChange(function () {
			return edmUserModel.currentUser;
		}, function (newValue, oldValue, scope) {
			if (newValue) {
				configureInterface();
			}
		}, $scope);
		
		$scope.bindChange(function () {
			return userModel.currentUser;
		}, function (newValue, oldValue, scope) {
			var loggedUser = newValue;

			if (loggedUser) {

				if (!$scope.checkedFirstConfiguration) {
					$scope.checkedFirstConfiguration = true;
					setRequredNotificationPopups(loggedUser);
				}

				if (loggedUser.medicalPostP1CertificateExpirationDate && moment().isAfter(moment(loggedUser.medicalPostP1CertificateExpirationDate).subtract(14, 'days'))) {
					showP1CertificateExpirationModal(false, loggedUser.medicalPostP1CertificateExpirationDate);
				}

				if (loggedUser.physicianP1CertificateExpirationDate && moment().isAfter(moment(loggedUser.physicianP1CertificateExpirationDate).subtract(14, 'days'))) {
					showP1CertificateExpirationModal(true, loggedUser.physicianP1CertificateExpirationDate);
				}

				configureInterface();
			}
		}, $scope);
		
		function setRequredNotificationPopups(loggedUser) {
			
			if (loggedUser.contractAcceptation || loggedUser.partnerType != Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN || loggedUser.originSystem === Enum.ORIGIN_SYSTEM.MEEDY_PROTECT) {
				checkWpAnnex_PasswordExpired(loggedUser);
			} else {
				applicationModel.viewReady = false;
				checkFirstLogin_WpAnnex_PasswordExpired(loggedUser);
			}
		}
		
		function checkWpAnnex_PasswordExpired(loggedUser) {
			
			storedDocumentModel.wpAnnexAvailable()
				.then(function (annexAvailable) {
					if (annexAvailable) {
						return showWpAnnexModal();
					} else {
						return 'Check password required';
					}
				})
				.catch(function (error) {
					// pass to password check if showWpAnnexModal rejects
					return 'Check password required';
				})
				
				.then(function () {
					return userModel.passwordExpired();
				})
				.then(function (data) {
					if (data.passwordExpired) {
						return showChangePasswordModal();
					} else {
						// password active so go to onCurrentUserChangedWithValidPassword
						return 'User password active';
					}
				})
				.then(function () {
					$scope.onCurrentUserChangedWithValidPassword(loggedUser);
				});
		}
		
		function checkFirstLogin_WpAnnex_PasswordExpired(loggedUser) {
			
			showFirstLoginModal()
				.catch(function (error) {
					authModel.invalidate();
					return $q.reject('stop');
				})
				
				.then(function () { // WpAnnex checking
					return storedDocumentModel.wpAnnexAvailable();
				})
				.then(function (annexAvailable) {
					if (annexAvailable) {
						return showWpAnnexModal();
					} else {
						return 'Check password required';
					}
				})
				.catch(function (error) {
					// reject if showFirstLoginModal is not confirmed
					if (error == 'stop') return $q.reject('stop');
					else return 'Check password required';
				})
				
				.then(function () {// Password expired checking
					return userModel.passwordExpired();
				})
				.then(function (data) {
					if (data.passwordExpired) {
						return showChangePasswordModal();
					} else {
						$scope.onCurrentUserChangedWithValidPassword(loggedUser);
						return $q.reject('User password active');
					}
				})
				.then(function () {
					userModel.getLoggedUser();
				});
		}
		
		
		function showFirstLoginModal() {
			if (config.COMPANY == 'clinic') {
				var templateUrl = 'meedy/application/clinicView/app/popup/popup-first-login.html';
			} else {
				var templateUrl = 'meedy/application/view/app/popup/popup-first-login.html';
			}

			return $mdDialog.show({
				templateUrl: templateUrl,
				controller: 'meedy.popupFirstLoginController',
				hasBackdrop: true,
				clickOutsideToClose: false,
				escapeToClose: false
			});
		}
		
		function showChangePasswordModal() {
			return $mdDialog.show({
				templateUrl: 'meedy/application/view/app/popup/popup-change-password.html',
				controller: 'meedy.popupChangePasswordController',
				hasBackdrop: true,
				clickOutsideToClose: false,
				escapeToClose: false
			})
		}

		function showP1CertificateExpirationModal(zusCopy, expirationDate) {
			$mdDialog.show({
				templateUrl: 'meedy/application/view/app/popup/popup-certificate-expiration.html',
				controller: 'meedy.popupCertificateExpirationController',
				hasBackdrop: true,
				clickOutsideToClose: false,
				escapeToClose: false,
				resolve: {
					zusCertificateCopy: function () {
						return zusCopy;
					},
					expirationDate: function () {
						return expirationDate;
					}
				}
			});
		}
		
		function showWpAnnexModal() {
			return $mdDialog.show({
				templateUrl: 'meedy/application/view/app/popup/popup-wp-annex.html',
				controller: 'meedy.popupWpAnnexController',
				hasBackdrop: true,
				clickOutsideToClose: false,
				escapeToClose: false
			})
		}
		
		$scope.onCurrentUserChangedWithValidPassword = function (loggedUser) {
			messagesModel.getUnreadMessages();
			
			var successMessage = $scope.$on(Event.MEEDY.MESSAGES.GET_UNREAD_MESSAGES.SUCCESS, function (event, messages) {
				successMessage();
				
				messagesModel.newMessages = messages.length;
			});
			
			applicationModel.isLoggedIn = true;
			
			$scope.startHeartbeat();
			
			if (loggedUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN) {
				if(userModel.currentUser.originSystem !== Enum.ORIGIN_SYSTEM.MEEDY_PROTECT) {
					wizardModel.checkIncompleteData();
				}
				var checkSuccessMessage = $scope.$on(Event.MEEDY.WIZARD.CHECK_INCOMPLETE_DATA.SUCCESS, function (event, message) {
					checkSuccessMessage();

					if (message != Enum.MEEDY.INCOMPLETE_DATA.NONE) {
						if (config.COMPANY == 'clinic') {
							var templateUrl = 'meedy/application/clinicView/app/popup/popup-new-user.html';
						} else {
							var templateUrl = 'meedy/application/view/app/popup/popup-new-user.html';
						}
						$scope.welcomeMessage = $mdDialog.show({
							templateUrl: 'meedy/application/view/app/popup/popup-new-user.html',
							controller: 'meedy.popupNewUserController'
						}).then(function () {
							
							$scope.fillBaseData = $mdDialog.show({
								templateUrl: 'meedy/application/view/app/wizard/popup/first-configuration-all-popup.html',
								controller: 'meedy.popupFirstConfigurationController',
								resolve: {
									mode: function () {
										return message;
									}
								},
								escapeToClose: false
							}).then(function () {
							}, function (error) {
							});
							
						}, function (error) {
						});
						
					}
				});
			}
			
		};
		
		
		// previous state / back / dirty / module management
		
		$window.onbeforeunload = function (event) {
			if ($scope.viewDirty) {
				return $scope.T('T.MEEDY.SYSTEM.MESSAGE.VIEW_DATA_LOSS_CONFIRMATION');
			}
		};
		
		/* ui router bugs workarounds - event.preventDefault() sometimes forces the url to reset to '/' */
		$rootScope.$on('$locationChangeStart', function (event, toUrl, fromUrl) {
			if (forceStateChange) {
				forceStateChange = false;
				if (toUrl.endsWith('#!/')) {
					event.preventDefault();
				}
			}
			else if (toUrl.endsWith('#!/') || toUrl.endsWith('#!') || toUrl.endsWith('#')) {
				event.preventDefault();
				$location.path('/meedy/home');
			}
		});
		
		$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
			$mdDialog.cancel();
			if (!(authInterceptor.token && authInterceptor.token.access_token) && !applicationModel.isLoggedIn && toState.name &&
				(toState.name !== Constant.STATE.PRE.MEEDY.LOGIN) &&
				(toState.name !== Constant.STATE.PRE.MEEDY.DEMO_LOGIN) &&
				(toState.name !== Constant.STATE.PRE.MEEDY.CHANGE_PASSWORD) &&
				(toState.name !== Constant.STATE.PRE.MEEDY.REMIND_PASSWORD) &&
				(toState.name !== Constant.STATE.PRE.MEEDY.VERIFICATION) &&
				(toState.name !== Constant.STATE.APP.MEEDY.ERROR.ACCESS_DENIED) &&
				(toState.name !== Constant.STATE.APP.MEEDY.ERROR.NOT_FOUND)) {
				
				if (toState.name != Constant.STATE.APP.MEEDY.HOME) {
					stateBeforeLogin = new ApplicationStateVO(toState, toParams);
					
				}
				
				forceStateChange = true;
				event.preventDefault();
				
				if (config.DEMO) {
					$state.go(Constant.STATE.PRE.MEEDY.DEMO_LOGIN);
				} else {
					$state.go(Constant.STATE.PRE.MEEDY.LOGIN);
				}
			}
			if (toState.redirectTo) {
				event.preventDefault();
				$state.go(toState.redirectTo, fromParams);
			}
			
			if (!edmUserModel.currentUser && toState.name.indexOf("meedy") == -1 && applicationModel.isLoggedIn) {
				event.preventDefault();
				$state.go(Constant.STATE.APP.MEEDY.HOME);
			}
			
			if (applicationModel.viewDirty) {
				forceStateChange = true;
				event.preventDefault();
				
				$mdDialog.show(
					$mdDialog.confirm()
						.content('T.MEEDY.SYSTEM.MESSAGE.VIEW_DATA_LOSS_CONFIRMATION')
				).then(
					function () {
						applicationModel.viewDirty = false;
						$state.go(toState.name, toParams);
					},
					function () {
						// nothing
					}
				);
			}
		});
		
		$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
			applicationModel.fillViewportMode = false;
			$mdComponentRegistry.when('left').then(function (it) {
				it.close();
			});
			if (goingToPreviousState) {
				goingToPreviousState = false;
			}
			else {
				if (fromState.name) {
					previousStateHistory.push(new ApplicationStateVO(fromState, fromParams));
				}
			}
			
			applicationModel.currentState = toState;
			applicationModel.currentUrl = $location.absUrl();
			
			var fromModule = undefined;
			_.forEach(applicationModel.modules, function (module) {
				var foundState = _.find(module.states, function (state) {
					return (state == fromState.name);
				});
				if (foundState) {
					fromModule = module.name;
				}
			});
			
			var toModule = undefined;
			_.forEach(applicationModel.modules, function (module) {
				var foundState = _.find(module.states, function (state) {
					return (state == toState.name);
				});
				if (foundState) {
					toModule = module.name;
				}
			});
			
			if (fromModule != toModule) {
				$rootScope.$broadcast(Event.MODULE_CHANGED, fromModule, toModule);
			}
		});

		$scope.$on(Event.MEEDY.USER.GET_LOGGED_USER.SUCCESS, function (event, error) {
			if (config.COMPANY == 'alab') {
				userModel.alabIntegrationAvailable().then(function () {
					configureInterface();
				});
			} else {
				configureInterface();
			}
		});
		
		// url debug overrides
		
		var debugUrlParameters = $location.search();
		
		if (debugUrlParameters.devMode) {
			var devMode = ($scope.$eval(debugUrlParameters.devMode) == true) ? true : false;
			applicationModel.devMode = devMode;
			$scope.devMode = applicationModel.devMode;
			$log.info('devMode override: ' + devMode);
		}
		if (debugUrlParameters.stats) {
			var stats = ($scope.$eval(debugUrlParameters.stats) == true) ? true : false;
			applicationModel.showPerformanceStats = stats;
			$log.info('  stats override: ' + stats);
		}
		
		// navigation shortcuts
		
		$scope.goBack = function (stateName, stateParams) {
			var previousState = previousStateHistory.pop();
			if (previousState) {
				goingToPreviousState = true;
				$state.go(previousState.getName(), previousState.params);
			} else {
				if (stateName) {
					$state.go(stateName, stateParams);
				}
			}
		};
		
		$scope.goToUrl = function (url, newWindow) {
			$window.open(url, newWindow ? '_blank' : '_self');
		};
		
		$scope.goToHome = function () {
			$state.go(Constant.STATE.APP.MEEDY.HOME);
		};
		
		$scope.goToPageNotFound = function () {
			$state.go(Constant.STATE.APP.MEEDY.ERROR.NOT_FOUND);
		};
		
		$scope.goToAccessDenied = function () {
			applicationModel.viewDirty = false;
			$state.go(Constant.STATE.APP.MEEDY.ERROR.ACCESS_DENIED);
		};
		
		// default
		
		$scope.emptyDbClick = function () {
			return false;
		};
		
		// loading management
		
		$scope.$on(Event.LOADING, function (event, isLoading) {
			if (isLoading) {
				applicationModel.isLoading = true;
			} else {
				applicationModel.isLoading = false;
			}
		});
		
		// login management
		
		$scope.$on(Event.MEEDY.AUTH.AUTHENTICATE.SUCCESS, function (event, user) {
			applicationModel.isLoggedIn = true;
			
			if (stateBeforeLogin) {
				$state.go(stateBeforeLogin.getName(), stateBeforeLogin.params);
				stateBeforeLogin = null;
			}
			else {
				$state.go(Constant.STATE.APP.MEEDY.HOME);
			}
		});
		
		$scope.$on(Event.MEEDY.FORCE_LOGOUT, function (event, data) {
			authModel.invalidate();
		});
		
		$scope.$on(Event.MEEDY.AUTH.INVALIDATE.SUCCESS, function (event, user) {
			applicationModel.isLoggedIn = false;
			authInterceptor.token = null;
			$timeout.cancel($scope.reconnectTimeout);
			sessionStorage.getItem('meedy_access_token');
			sessionStorage.getItem('meedy_refresh_token');
			sessionStorage.getItem('edm-cookie');
			var isViprotectUser = userModel.currentUser.originSystem === Enum.ORIGIN_SYSTEM.MEEDY_PROTECT;
			userModel.currentUser = null;
			
			if (videoConsultationModel.stompClient) {
				videoConsultationModel.stompClient.disconnect(function () {
					console.log("disconnect and logout");
				});
			}
			
			if (config.DEMO) {
				$state.go(Constant.STATE.PRE.MEEDY.DEMO_LOGIN);
			} else if (isViprotectUser) {
				sessionStorage.removeItem('meedy_access_token');
				sessionStorage.removeItem('meedy_refresh_token');
				sessionStorage.removeItem('edm-cookie');
				$cookies.remove('meedy_access_token');
				$cookies.remove('meedy_refresh_token');
				$cookies.remove('edm-cookie');
				window.location = 'https://zdalnylekarz.meedy.pl/#/login';
			} else {
				$state.go(Constant.STATE.PRE.MEEDY.LOGIN);
			}
		});
		
		// error / notification management
		
		$scope.$on(Event.MEEDY.ACCESS_DENIED, function (event) {
			//applicationModel.isLoggedIn = false;
			//$state.go(Constant.STATE.PRE.MEEDY.LOGIN);
			$state.go(Constant.STATE.APP.MEEDY.ERROR.ACCESS_DENIED);
		});
		
		$scope.$on(Event.MEEDY.USER.GET_LOGGED_USER.ERROR, function (event) {
			//TODO Powinno się odpalać Access Denied z pre
			applicationModel.isLoggedIn = false;
			
			if (config.DEMO) {
				$state.go(Constant.STATE.PRE.MEEDY.DEMO_LOGIN);
			} else {
				$state.go(Constant.STATE.PRE.MEEDY.LOGIN);
			}
		});
		
		$scope.$on(Event.ERROR, function (event, error) {
			$timeout(function () {
				$mdToast.show(
					$mdToast.simple({
						content: $scope.T(error.message),
						hideDelay: 3000,
						position: 'top right',
						parent: $(".md-dialog-container")[0] != null ? $(".md-dialog-container")[0] : $("body")[0] //mdToast in popup bug
					}).theme('error')
				);
			});
		});

		$scope.$on(Event.VALIDATION_ERROR, function (event, error) {

			$mdDialog.show({
				templateUrl: 'meedy/application/view/app/popup/popup-error.html',
				controller: 'popupErrorController',
				resolve: {
					error: function () {
						return error;
					}
				}
			});
		});
		
		$scope.$on(Event.INTERNAL_ERROR, function (event, rejection) {
			// rejection is HttpResponseVO
			if ($scope.devMode) {
				var internalError = new ErrorVO('T.MEEDY.SYSTEM.ERROR.ERROR', 'T.MEEDY.SYSTEM.ERROR.INTERNAL_ERROR', 'T.MEEDY.SYSTEM.ERROR.CONTACT_ADMINISTRATOR',
					(rejection && rejection.data && rejection.config.url) ? [rejection.data, rejection.config.url + ' (' + rejection.config.method + ')'] : null);
				
				$mdDialog.show({
					templateUrl: 'meedy/application/view/app/popup/popup-error.html',
					controller: 'popupErrorController',
					resolve: {
						error: function () {
							return internalError;
						}
					}
				});
			}
		});
		
		$scope.$on(Event.MEEDY.NOTIFICATION, function (event, notification) {
			$timeout(function () {
				$mdToast.show(
					$mdToast.simple({
						content: $scope.T(notification.title),
						hideDelay: 2000,
						position: 'top right',
						parent: $(".md-dialog-container")[0] != null ? $(".md-dialog-container")[0] : $("body")[0]
					}).theme(notification.type)
				);
			});
		});

		$scope.$on(Event.MEEDY.BAD_REQUEST_WITH_MESSAGE, function (event, notification) {
			$timeout(function () {
				$mdToast.show(
					$mdToast.simple({
						content: $scope.T(notification.data.errorMessage),
						hideDelay: 10000,
						position: 'top right',
						parent: $(".md-dialog-container")[0] != null ? $(".md-dialog-container")[0] : $("body")[0]
					}).theme('error')
				);
			});
		});
		
		$scope.notifyValidationError = function () {
			$rootScope.$broadcast(Event.MEEDY.NOTIFICATION, new NotificationVO(Enum.NOTIFICATION_TYPE.WARNING, 'T.MEEDY.SYSTEM.VALIDATION.VALIDATION_MESSAGE'));
		};
		
		// interrupts
		
		$document.find('html').on('mousemove keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll', function (event) {
			if (event.type === 'mousemove' && event.originalEvent && event.originalEvent.movementX === 0 && event.originalEvent.movementY === 0) {
				return; // Fix for Chrome desktop notifications, triggering mousemove event.
			}
			$scope.didAction++;
		});
		
		// module setup
		
		var states = $state.get();
		var modules = [];
		
		_.each(states, function (state) {
			if (state.data && state.data.module) {
				var stateModuleName = state.data.module;
				
				var existingModule = _.find(modules, function (module) {
					return (module.name == stateModuleName);
				});
				
				if (existingModule) {
					existingModule.states.push(state.name);
				}
				else {
					var newModule = new ApplicationModuleVO();
					newModule.name = stateModuleName;
					newModule.states = [];
					newModule.states.push(state.name);
					
					modules.push(newModule);
				}
			}
		});
		
		function configureInterface() {
			//var applicationItems = [];
			//
			//applicationModel.setApplicationItems(applicationItems);
			
			var sideBarItems;
			if(!!userModel.currentUser.alabDiagnostician) {
				sideBarItems = menuAlabDiagnostician();
			} else if(userModel.currentUser.originSystem === Enum.ORIGIN_SYSTEM.MEEDY_PROTECT) {
				sideBarItems = menuDoctorProtect();
			} else {
				sideBarItems = menuDefault();
			}
			
			applicationModel.setSideBarItems(sideBarItems);
		}
		
		function menuAlabDiagnostician() {
			return [
				objectHelper.translateObject({
					name: "{{ 'T.MEEDY.UI.SIDEBAR.SECOND_DIAGNOSIS' | translate }}",
					icon: 'ss-compose',
					state: Constant.STATE.APP.MEEDY.SECOND_DIAGNOSIS.LIST,
					badge: 0
				}, EsSidebarItem),
				objectHelper.translateObject({
					name: "{{ 'T.MEEDY.UI.SIDEBAR.CONFIGURATION' | translate }}",
					icon: 'icon-settings-01',
					state: Constant.STATE.APP.MEEDY.SETTINGS.MY_DATA
				}, EsSidebarItem)
			];
		}

		function menuDoctorProtect() {
			return [
				objectHelper.translateObject({
					name: "{{ 'T.MEEDY.UI.SIDEBAR.CALENDAR' | translate }}",
					icon: 'icon-calendar-01',
					state: Constant.STATE.APP.MEEDY.CALENDAR.DAILY_PLAN,
					bade: 0
				}, EsSidebarItem),
				objectHelper.translateObject({
					name: "{{ 'T.MEEDY.UI.SIDEBAR.CONFIGURATION' | translate }}",
					icon: 'icon-settings-01',
					state: Constant.STATE.APP.MEEDY.SETTINGS.MY_DATA
				}, EsSidebarItem)
			];
		}
		
		function menuDefault() {
			return [
				objectHelper.translateObject({
					name: "{{ 'T.MEEDY.UI.SIDEBAR.CALENDAR' | translate }}",
					icon: 'icon-calendar-01',
					state: Constant.STATE.APP.MEEDY.CALENDAR.INDEX
				}, EsSidebarItem),
				objectHelper.translateObject({
					name: "{{ 'T.MEEDY.UI.SIDEBAR.PATIENTS' | translate }}",
					icon: 'ss-users',
					state: Constant.STATE.APP.PATIENT.LIST,
					visible: userModel.currentUser.inEdm && edmUserModel.currentUser
				}, EsSidebarItem),//EDM state
				objectHelper.translateObject({
					name: "{{ 'T.MEEDY.UI.SIDEBAR.MESSAGES' | translate }}",
					icon: 'ss-chat',
					state: Constant.STATE.APP.MEEDY.MESSAGES.LIST,
					badge: 0
				}, EsSidebarItem),
				objectHelper.translateObject({
					name: "{{ 'T.MEEDY.UI.SIDEBAR.SECOND_DIAGNOSIS' | translate }}",
					icon: 'ss-compose',
					state: Constant.STATE.APP.MEEDY.SECOND_DIAGNOSIS.LIST,
					badge: 0,
					visible: userModel.currentUser.saneoCooperation
				}, EsSidebarItem),
				objectHelper.translateObject({
					name: "{{ 'T.MEEDY.UI.SIDEBAR.INVOICES_ORDERS' | translate }}",
					icon: 'ss-file',
					state: Constant.STATE.APP.MEEDY.INVOICE.LIST,
					visible: userModel.currentUser.saneoCooperation
				}, EsSidebarItem),
				objectHelper.translateObject({
					name: "{{ 'T.UI.SIDEBAR_ITEMS.MEDICAL_DOCUMENTATION' | translate }}",
					icon: 'ss-notebook',
					state: Constant.STATE.APP.FILL_DATA,
					visible: userModel.currentUser.inEdm && edmUserModel.currentUser && edmUserModel.userHasRight(Constant.RIGHT.VISIT_CARD_MODULE_ACCESS)
				}, EsSidebarItem),
				objectHelper.translateObject({
					name: "{{ 'T.MEEDY.UI.SIDEBAR.CONFIGURATION' | translate }}",
					icon: 'icon-settings-01',
					state: Constant.STATE.APP.MEEDY.SETTINGS.MY_DATA,
					visible: userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN
				}, EsSidebarItem),
				objectHelper.translateObject({
					name: "{{ 'T.MEEDY.UI.SIDEBAR.CONFIGURATION' | translate }}",
					icon: 'icon-settings-01',
					state: Constant.STATE.APP.MEEDY.SETTINGS.OFFICE.LIST,
					visible: userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.RECEPTIONIST || userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.MEDICAL_RECEPTIONIST
				}, EsSidebarItem),
				objectHelper.translateObject({
					name: "{{ 'T.MEEDY.UI.SIDEBAR.DELEGATE_TO_ALAB' | translate }}",
					icon: 'ss-notebook',
					state: Constant.STATE.APP.MEEDY.ALAB.LIST,
					visible: userModel.userHasRightForALAB
				}, EsSidebarItem),
				objectHelper.translateObject({
					name: "{{ 'T.MEEDY.UI.SIDEBAR.OPINION' | translate }}",
					icon: 'icon-smile',
					state: Constant.STATE.APP.MEEDY.OPINION.ADD,
					breakHr: true
				}, EsSidebarItem)
			];
		}
		
		
		
		applicationModel.setModules(modules);
		
		// performance stats
		
		if (applicationModel.showPerformanceStats) {
			var ngStats = showAngularStats({position: 'bottomright'});
		}
		
		applicationModel.customConfig = {
			faviconUrl: 'meedy/resource/asset/' + config.COMPANY != 'null' ? config.COMPANY : 'meedy' + '-logo-small.png'
		};

		var $draggable = $('#video-popup').draggabilly({});
		
		
		/**
		 * detect IE
		 * returns version of IE or false, if browser is not Internet Explorer
		 */
		function detectIE() {
			var ua = window.navigator.userAgent;
			
			var msie = ua.indexOf('MSIE ');
			if (msie > 0) {
				// IE 10 or older => return version number
				$("#ng-app").addClass('ie10');
				return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
			}
			
			var trident = ua.indexOf('Trident/');
			if (trident > 0) {
				// IE 11 => return version number
				var rv = ua.indexOf('rv:');
				$("#ng-app").addClass('ie11');
				return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
			}
			
			var edge = ua.indexOf('Edge/');
			if (edge > 0) {
				// Edge (IE 12+) => return version number
				$("#ng-app").addClass('edge');
				return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
			}
			
			// other browser
			return false;
		}
		
		detectIE();
		
	}
]);
